import React, { Component } from "react";
import styled, { css } from "styled-components";

const ScSvg = styled.svg`
  width: ${({ width }) => (width ? width : "50px")};
  height: ${({ height }) => (height ? height : "50px")};
  border-radius: 7px;
  padding: 7px;
  border: 1px solid ${({ theme, active }) => theme.colors.primary.main};
  fill: ${({ theme, active }) => theme.colors.primary.main};
  background: #f4f2f1;
  transition: 200ms linear all;
  cursor: pointer;
  color: black;

  &:hover {
    fill: white;

    background: ${({ theme, active }) => theme.colors.primary.main};
  }
  ${({ active, theme }) => {
    return (
      active &&
      css`
        fill: white;

        background: ${theme.colors.primary.main};
      `
    );
  }}
`;

export class ScWaterfallIcon extends Component {
  render() {
    return (
      <ScSvg
        viewBox="0 0 1105 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path d="M527.259156 734.780022V537.096695h-34.157104v76.304923a42.147819 42.147819 0 0 1-42.348958 42.751236H246.816164a42.18439 42.18439 0 0 1-42.495241-42.751236v-76.286638H132.678774v197.683327h114.13739a42.550097 42.550097 0 0 1 42.367243 42.330673v203.93693c0 23.295584-18.998518 42.93409-42.367243 42.93409H42.312387C19.601936 1023.981715 0 1004.361494 0 981.047624V777.110694c0-23.11273 19.601936-42.330673 42.312387-42.330672h39.331869V511.606864c0-13.860324 11.282084-24.941269 25.160694-24.941269H204.302637v-76.780343a42.568383 42.568383 0 0 1 42.495242-42.69638h36.131926V144.893413c0-13.878609 12.214639-25.855538 25.837253-25.855539H408.239567V42.93409A42.604953 42.604953 0 0 1 450.734808 0h204.394065c22.856735 0 42.440385 19.035089 42.440385 42.93409V119.037874H797.041767c13.531187 0 24.941269 11.976929 24.941269 25.855539v222.295459h36.973054c23.35044 0 42.988947 19.071659 42.988947 42.69638V486.665595h96.784557c14.134605 0 25.45326 11.080945 25.45326 24.941269v223.154872h38.728451c23.917287 0 42.915805 19.236228 42.915805 42.330673v203.93693a43.062088 43.062088 0 0 1-42.915805 42.93409H858.974375c-23.332155 0-42.93409-19.620221-42.93409-42.93409V777.110694c0-23.11273 19.58365-42.330673 42.93409-42.330672h114.722523V537.096695h-71.733576v76.304923a42.65981 42.65981 0 0 1-42.988947 42.751236H655.128873c-23.990429 0-42.988947-18.431671-42.988947-42.751236v-76.286638h-33.97425v197.683327h76.963197c22.856735 0 42.440385 19.236228 42.440385 42.330673v203.93693c0 23.295584-19.58365 42.93409-42.440385 42.93409H450.734808c-23.460152 0-42.476956-19.620221-42.476955-42.93409V777.110694a42.568383 42.568383 0 0 1 42.476955-42.330672H527.259156z m-34.157104-248.114427H612.158211v-76.780343a42.65981 42.65981 0 0 1 42.988947-42.69638h116.423064V170.163819h-73.964394v76.67063c0 23.332155-19.58365 42.751237-42.440385 42.751237H450.734808c-23.460152 0-42.476956-19.419082-42.476955-42.751237V170.163819h-73.946109v197.025053h116.423064a42.550097 42.550097 0 0 1 42.348958 42.69638V486.665595h0.018286z m0-401.583686v119.019589h119.056159V85.081909h-119.056159z m467.849931 734.524027h-58.988661v119.074445h118.800164v-119.074445h-59.811503z m-875.888359 0v119.074445h119.239013v-119.074445H85.063624z m408.038428 0v119.074445h119.056159v-119.074445h-119.056159z m-203.918645-367.353441V571.912073h119.074446V452.252495h-119.074446z m408.385851 0V571.912073h118.471027V452.252495h-118.471027z" />
      </ScSvg>
    );
  }
}

{
  /* <ScSvg
viewBox="0 0 1024 1024"
version="1.1"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M383.599661 95.397443h543.683107v69.655943h-543.683107zM383.599661 284.803942h543.683107v69.655942h-543.683107zM383.599661 669.777657h543.683107v69.655942h-543.683107zM383.599661 859.184155h543.683107v69.655943h-543.683107zM95.887885 465.562705h831.394883v92.875614h-831.394883zM177.967652 354.460908h46.437295V200.695858h82.079767L201.186299 95.397443 95.887885 200.695858h82.079767zM224.404947 669.777657h-46.437295v153.764026h-82.079767L201.186299 928.840098l105.298415-105.298415h-82.079767z"
  fill=""
/>
</ScSvg>
<ScSvg
viewBox="0 0 1024 1024"
version="1.1"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M512.363479 668.237733V564.087094h416.649656v104.150639h-416.649656z m0-520.812581h416.649656v104.168046h-416.649656V147.425152zM95.523381 772.405779h104.358488V616.156782h104.156783v156.25002h104.353368l-156.4292 156.433296-156.439439-156.434319z m208.515271-364.573824H199.881869V251.594221H95.523381l156.439439-156.434319 156.428176 156.434319H304.038652v156.237734z m520.811557 52.087094H512.363479V355.74998h312.487754v104.169069z m0 416.643512H512.363479V772.405779h312.487754v104.156782z"
  fill="#323333"
/>
</ScSvg> */
}
